import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Button } from "arv-reactcomponents";
import { isDesktop } from "../../../utils";

@inject("ProductStore")
@observer
class MobileFilterButtons extends Component {
  constructor() {
    super();
    this.toggleMobileFilter = this.toggleMobileFilter.bind(this);
  }

  componentDidMount() {
    const headerContainer = document.querySelectorAll(
      ".nw-header-container",
    )[0];
    if (headerContainer) {
      headerContainer.style.minHeight = "140px";
    }
  }

  componentWillUnmount() {
    const headerContainer = document.querySelectorAll(
      ".nw-header-container",
    )[0];
    headerContainer.style.minHeight = null;
  }

  toggleMobileFilter(type, event) {
    event.preventDefault();
    this.props.ProductStore.toggleMobileFilters(type);
  }

  render() {
    const { showMobileFilters, disableFilters } = this.props.ProductStore;
    if (!showMobileFilters) return null;
    const RenderComponent = (
      <div className="nw-mobilefilterbuttons">
        <Button
          className="nw-mobilefilterbuttons-item nwc-btn-secondary"
          onClick={event => {
            this.toggleMobileFilter("refine", event);
          }}
          disabled={disableFilters}
        >
          REFINE
        </Button>
        <Button
          className="nw-mobilefilterbuttons-item nwc-btn-secondary"
          onClick={event => {
            this.toggleMobileFilter("sortBy", event);
          }}
          disabled={disableFilters}
        >
          SORT BY
        </Button>
      </div>
    );
    if ((global && global.isServer) || isDesktop) {
      return null;
    }
    return ReactDOM.createPortal(
      RenderComponent,
      document.querySelector(".nw-mobileheader-mobilefilterbuttons"),
    );
  }
}
MobileFilterButtons.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({
    disableFilters: PropTypes.bool.isRequired,
    toggleMobileFilters: PropTypes.func.isRequired,
    showMobileFilters: PropTypes.bool.isRequired,
  }).isRequired,
};
export default MobileFilterButtons;



// WEBPACK FOOTER //
// ./src/component/MobileFilters/MobileFilterButton/index.js